import { render, staticRenderFns } from "./InvoiceSettingsDialog.vue?vue&type=template&id=52e4780e&lang=pug&"
import script from "./InvoiceSettingsDialog.vue?vue&type=script&lang=ts&"
export * from "./InvoiceSettingsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports